var EvaluationService = require('services/evaluation-service');
import toPromise from 'lib/to-promise';

var PollService = function() {
  this.renderPoll = function(blockView) {
    if(EF.options.local) {
      let options = { parse: true };
      blockView.poll.fetch(options).done(() => {
        blockView.poll.property('text', () => { blockView.model.set('text', blockView.poll.get('text')); });
        blockView.poll.property('id', () => { blockView.model.set('id', blockView.poll.get('id')); });
        blockView.poll.property('answers', () => { blockView.model.set('answers', blockView.poll.get('answers')); });
        blockView.render();
      });
    } else {
      blockView.render();
    }
  };

  this.getUrl = function(model) {
    var enrollmentId = EF.enrollment.get('id');
    return EF.url('/sdk/enrollments/' + enrollmentId + '/poll.json');
  };

  this.parse = function(response) {
    return response;
  };

  this.save = function(model, options) {
    if(EF.options.local) {
      return new Promise((resolve) => {
        var totals = [ ];
        model.get('answers').forEach((a) => {
          totals.push({ id: a.id, count: Math.floor(Math.random() * (500 - 1) + 1 )});
        });
        model.set('totals', totals);
        if(options && options.success) {
          options.success({ totals });
        }
        resolve({ totals });
      });
    } else {
      return toPromise(Backbone.Model.prototype.save.apply(model));
    }
  };
};

module.exports = new PollService();
